export default __webpack_public_path__ + "static/media/screen_zendesk_3.8fa31855.png";